import React from 'react';
import PropTypes from 'prop-types';
import { omitBy, isEmpty, isEqual } from 'lodash';

import { Filter, ActiveFilters } from '../../components/Filters';

import './Homepage.css';

const HomePageFilters = ({
  filters,
  handleFilterChange,
  appliedFilters,
  stateFilters,
  onClearFunc,
  onClearAllFunc,
  applyFunc,
  applyClearFunc
}) => {
  const getActiveFilters = filter =>
    omitBy({ [filter.id]: filter }, ({ value }) => isEmpty(value));

  // const resetDisabled = () =>
  //   !stateFilters.country &&
  //   isEqual(appliedFilters, stateFilters) &&
  //   appliedFilters.contentType.value !== 'shows';

  return (
    <div className="homepage__filters-row">
      {filters.map(f => (
        <div className={`homepage__filter-col ${f.id}`}>
          <div className={`homepage__filter ${f.id}`}>
            <div className="homepage__filter-label">{f.label}:</div>
            <Filter
              key={f.id}
              hasChanged={f.hasChanged}
              onChange={handleFilterChange}
              onUpdateFilterOptions={() => {}}
              id={f.id}
              title={f.label}
              hasBoolean={false}
              {...f}
            />
          </div>
          {stateFilters[f.id] &&
          stateFilters[f.id].length &&
          !f.hideActiveFilters ? (
            <ActiveFilters
              filters={getActiveFilters(f)}
              onClear={onClearFunc}
              onClearAll={onClearAllFunc(f.id)}
            />
          ) : null}
        </div>
      ))}
      <button
        disabled={isEqual(appliedFilters, stateFilters)}
        className={`homepage__filter-action-button ${
          !isEqual(appliedFilters, stateFilters) ? 'active' : 'apply-disabled'
        }`}
        onClick={applyFunc}
      >
        Apply
      </button>
      {/* <button
        disabled={resetDisabled()}
        className={`homepage__filter-action-button ${
          resetDisabled() ? 'reset-disabled' : 'reset'
        }`}
        onClick={applyClearFunc}
      >
        Reset
      </button> */}
    </div>
  );
};

export default HomePageFilters;

HomePageFilters.propTypes = {
  filters: PropTypes.shape([]).isRequired,
  appliedFilters: PropTypes.shape([]).isRequired,
  stateFilters: PropTypes.shape([]).isRequired,
  handleFilterChange: PropTypes.func.isRequired,
  applyFunc: PropTypes.func.isRequired,
  applyClearFunc: PropTypes.func.isRequired,
  onClearFunc: PropTypes.func.isRequired,
  onClearAllFunc: PropTypes.func.isRequired
};
